import { useNavigate } from '@lib/react-router-dom'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useModal } from '@context/ModalsContext'
import { useNavigationMode } from '@context/NavigationModeContext'

import { CommonPaths } from '@utils/path-common'

import {
  CFDLandingPageID,
  ETDLandingPageID,
  GenericLandingPageID,
  LandingPageMapping,
} from '@model/LandingPageDto'

import { TradersToPartnerModal } from '@shared/components/Navigation/ProductSwitch/modals/TradersToPartner.modal'

export const useAccountSwitch = (onClose?: () => void) => {
  const { navigationMode, setNavigationMode } = useNavigationMode()
  const navigate = useNavigate()
  const { account } = useAccountReadContext()
  const accountIsIb = !!account?.clientIntroducingBroker?.id
  const isDashboardPoCActive = true

  const preferredLandingPage = account?.preferredLandingPage?.id
  const mappedLandingPage =
    preferredLandingPage && preferredLandingPage in LandingPageMapping
      ? LandingPageMapping[
          preferredLandingPage as ETDLandingPageID | CFDLandingPageID | GenericLandingPageID
        ]
      : undefined
  const isLandingPageTradersRoom = mappedLandingPage?.includes('/traders-room') ?? false
  const isLandingPageIb = mappedLandingPage?.includes('introducing-broker') ?? false

  const traderOnClick = () => {
    setNavigationMode('partner')
    const targetPath = isLandingPageIb
      ? mappedLandingPage
      : isDashboardPoCActive
      ? CommonPaths.IntroducingBrokerDashboard
      : CommonPaths.IntroducingBrokerWallets
    if (targetPath) {
      navigate(targetPath)
    }
  }

  const partnerOnClick = () => {
    setNavigationMode('trader')
    const targetPath = isLandingPageTradersRoom ? mappedLandingPage : CommonPaths.TradersRoomWallets
    if (targetPath) {
      navigate(targetPath)
    }
  }

  const traderToPartnerModal = useModal(TradersToPartnerModal, {
    switchMenu: traderOnClick,
    onAccept: onClose,
  })
  const partnerToTraderModal = useModal(TradersToPartnerModal, {
    partnerToTrader: true,
    switchMenu: partnerOnClick,
    onAccept: onClose,
  })

  return () => {
    if (accountIsIb) {
      if (navigationMode === 'trader') {
        traderToPartnerModal.open()
      } else {
        partnerToTraderModal.open()
      }
    } else {
      navigate('/dashboard/introducing-broker/register/type')
    }
  }
}
